import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/Badge';

const statusColors = {
  incomplete: 'red',
  incomplete_expired: 'red',
  trialing: 'yellow',
  active: 'green',
  past_due: 'yellow',
  canceled: 'red',
  unpaid: 'red',
};

const SubscriptionStatusBadge = ({ className, status }) => (
  <Badge
    text={status}
    colorClass={statusColors[status]}
    className={className}
  />
);

SubscriptionStatusBadge.propTypes = {
  className: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(statusColors)),
};

export default SubscriptionStatusBadge;
